import script from "./UserTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTickets.vue?vue&type=script&setup=true&lang=js"

import "./UserTickets.vue?vue&type=style&index=0&id=095cab35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-095cab35"]])

export default __exports__